import React from "react";
import styles from "./service-request-share-bottom-bar.module.scss";
import { ImageIcon, SharePdfIcon } from "../../../../../assets/icons";

interface ServiceRequestShareBottomBarProps {
	onShareImage: () => void;
	onSharePdf: () => void;
	isSharingImage?: boolean;
	isSharingPdf?: boolean;
}

const ServiceRequestShareBottomBar: React.FC<ServiceRequestShareBottomBarProps> = ({
	onShareImage,
	onSharePdf,
	isSharingImage = false,
	isSharingPdf = false,
}) => {
	return (
		<div className={styles.bottomBar}>
			<button
				type="button"
				className={styles.shareButton}
				onClick={onShareImage}
				disabled={isSharingImage}
			>
				{isSharingImage ? (
					<span className={styles.spinner} />
				) : (
					<>
						<ImageIcon className={styles.buttonIcon} />
						<span className={styles.buttonText}>Share as Image</span>
					</>
				)}
			</button>

			<button
				type="button"
				className={styles.shareButton}
				onClick={onSharePdf}
				disabled={isSharingPdf}
			>
				{isSharingPdf ? (
					<span className={styles.spinner} />
				) : (
					<>
						<SharePdfIcon className={styles.buttonIcon} />
						<span className={styles.buttonText}>Share as PDF</span>
					</>
				)}
			</button>
		</div>
	);
};

export default ServiceRequestShareBottomBar;
